// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const runPatchCrmReferenceOneMax = 120;

export const runPatchFeedbackCommentOneMax = 2000;

export const RunPatch = zod.object({
  "crm_reference": zod.union([zod.string().max(runPatchCrmReferenceOneMax),zod.null()]).optional(),
  "feedback": zod.union([zod.enum(['useful', 'not_useful']),zod.null()]).optional(),
  "feedback_comment": zod.union([zod.string().max(runPatchFeedbackCommentOneMax),zod.null()]).optional(),
  "outcome": zod.union([zod.enum(['used_in_proposal', 'shared_with_client', 'won', 'lost']),zod.null()]).optional()
});

export type RunPatch = zod.input<typeof RunPatch>;
export type RunPatchOutput = zod.output<typeof RunPatch>;
